import { render, staticRenderFns } from "./PianoShooter.vue?vue&type=template&id=b6516eb8&scoped=true"
import script from "./PianoShooter.vue?vue&type=script&lang=ts"
export * from "./PianoShooter.vue?vue&type=script&lang=ts"
import style0 from "./PianoShooter.vue?vue&type=style&index=0&id=b6516eb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6516eb8",
  null
  
)

export default component.exports